/**
 * @fileoverview > handler for the "/users/preference_center" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { usersPreferenceCenter } from "./constants";
import type { PostUsersPreferenceCenterProps, UsersPreferenceCenterResult } from "./types";

export const postUsersPreferenceCenter = reactQueryMutationAdapter(
  usersPreferenceCenter,
  async (props: PostUsersPreferenceCenterProps): Promise<UsersPreferenceCenterResult> => {
    return fetch("/users/preference_center", "POST", props);
  }
);
